module.exports = __webpack_public_path__ + "stat-reviews.svg?925dfcb8ff62e98f7fa9ee03a33ae734";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stat-reviews.svg
// module id = 326
// module chunks = 2